import React from "react";
import { motion } from "framer-motion";
import { BtnSignature } from "./BtnSignature";

/**
 * NextActionPanel — l'unique CTA visible sur la fiche dossier.
 * Répond simultanément à 3 questions :
 *   1. QUOI  — quelle action ?      (title)
 *   2. POURQUOI — pourquoi cette action ?  (why)
 *   3. CONSÉQUENCE — que va-t-il se passer ?  (consequence)
 *
 * "Le commercial comprend instantanément ce qu'il fait et ce que cela déclenche."
 */
export function NextActionPanel({
  overline = "Prochaine action",
  title,
  why,
  consequence,
  cta,
  ctaVariant = "lime",
  ctaArrow = true,
  onCta,
  meta = null,
  helperText = null,
  children,
  testid,
}) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
      data-testid={testid}
      className="shadow-wyvio-elev rounded-[24px] bg-white"
    >
      <div className="flex flex-col gap-10 p-12">
        {/* Bloc principal : action + méta */}
        <div>
          <div className="flex items-center gap-3">
            <span
              aria-hidden
              className="inline-block h-1.5 w-1.5 rounded-full"
              style={{ background: "#C8FF2F" }}
            />
            <p className="text-[10.5px] font-medium uppercase tracking-[0.28em] text-[#8A8A80]">
              {overline}
            </p>
          </div>

          <h2 className="mt-6 max-w-[560px] text-[38px] font-medium leading-[1.05] tracking-[-0.025em] text-[#151515]">
            {title}
          </h2>

          {meta && (
            <p className="mt-6 text-[11.5px] font-medium uppercase tracking-[0.22em] text-[#8A8A80]">
              {meta}
            </p>
          )}
        </div>

        {/* Bloc Pourquoi / Conséquence */}
        {(why || consequence) && (
          <div className="grid grid-cols-2 gap-8 border-t border-[#E8E8E2] pt-8">
            {why && (
              <div>
                <p className="text-[10.5px] font-medium uppercase tracking-[0.22em] text-[#8A8A80]">
                  Pourquoi
                </p>
                <p className="mt-3 text-[14px] font-normal leading-[1.55] text-[#151515]">
                  {why}
                </p>
              </div>
            )}
            {consequence && (
              <div>
                <p className="text-[10.5px] font-medium uppercase tracking-[0.22em] text-[#8A8A80]">
                  Conséquence
                </p>
                <p className="mt-3 text-[14px] font-normal leading-[1.55] text-[#151515]">
                  {consequence}
                </p>
              </div>
            )}
          </div>
        )}

        {/* CTA unique */}
        <div className="border-t border-[#E8E8E2] pt-8">
          <BtnSignature
            variant={ctaVariant}
            size="lg"
            arrow={ctaArrow}
            onClick={onCta}
            testid={`${testid}-cta`}
          >
            {cta}
          </BtnSignature>
          {helperText && (
            <p className="mt-4 text-[11.5px] font-normal text-[#8A8A80]">
              {helperText}
            </p>
          )}
        </div>

        {/* Contexte contextuel (ex: créneaux) */}
        {children && (
          <div className="border-t border-[#E8E8E2] pt-8">{children}</div>
        )}
      </div>
    </motion.section>
  );
}
